export default __webpack_public_path__ + "22.06.2017_PM_LifeTime_bringt_neue_Produktgeneration_auf_den_Markt25b68426a34ad37c10139b2fd79bdda7.pdf";